
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import api from '../services/api';
import logo from '../images/logo.png';

const Register = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        password2: '',
        first_name: '',
        last_name: '',
        role: 'student',
        bio: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        // Walidacja hasła
        if (formData.password !== formData.password2) {
            setError('Hasła nie są identyczne');
            setLoading(false);
            return;
        }

        try {
            const response = await api.post('/register/', {
                username: formData.username,
                email: formData.email,
                password: formData.password,
                password2: formData.password2,
                first_name: formData.first_name,
                last_name: formData.last_name,
                role: formData.role,
                bio: formData.bio,
            });

            setSuccess('✅ Rejestracja udana! Za chwilę zostaniesz przekierowany na stronę logowania.');

            // Po 2 sekundach przekieruj do logowania
            setTimeout(() => {
                navigate('/login');
            }, 2000);

        } catch (err) {
            console.error('Błąd rejestracji:', err);

            if (err.response?.data) {
                const errors = err.response.data;
                // Wyświetl pierwszy błąd
                const firstError = Object.values(errors).flat()[0];
                setError(firstError || 'Błąd podczas rejestracji');
            } else {
                setError('Błąd połączenia z serwerem');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex min-vh-100 align-items-center justify-content-center py-5">
            <Row className="w-100">
                <Col md={8} lg={6} className="mx-auto">
                    <Card className="shadow">
                        <Card.Body className="p-4" className="text-center">
                            <img
                                src={logo}
                                alt="LMS Logo"
                                style={{
                                    height: '60px',
                                    width: '160px',
                                    marginRight: '12px',
                                    backgroundColor: '#ffffff',
                                }}></img>
                            <h4 className="text-center mb-4">Rejestracja</h4>

                            {error && <Alert variant="danger">{error}</Alert>}
                            {success && <Alert variant="success">{success}</Alert>}

                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Imię</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="first_name"
                                                value={formData.first_name}
                                                onChange={handleChange}
                                                placeholder="Twoje imię"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nazwisko</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="last_name"
                                                value={formData.last_name}
                                                onChange={handleChange}
                                                placeholder="Twoje nazwisko"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Form.Label>Nazwa użytkownika *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleChange}
                                        placeholder="Wybierz nazwę użytkownika"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Adres email *</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="twoj@email.pl"
                                        required
                                    />
                                </Form.Group>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Hasło *</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                placeholder="Minimum 8 znaków"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Powtórz hasło *</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password2"
                                                value={formData.password2}
                                                onChange={handleChange}
                                                placeholder="Powtórz hasło"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Form.Label>Rola</Form.Label>
                                    <Form.Select
                                        name="role"
                                        value={formData.role}
                                        onChange={handleChange}
                                    >
                                        <option value="student">👨‍🎓 Student</option>
                                        <option value="instructor">👨‍🏫 Instruktor</option>
                                    </Form.Select>
                                    <Form.Text className="text-muted">
                                        Instruktorzy mogą tworzyć i zarządzać kursami.
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Krótkie bio (opcjonalne)</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        name="bio"
                                        value={formData.bio}
                                        onChange={handleChange}
                                        placeholder="Napisz coś o sobie..."
                                    />
                                </Form.Group>

                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="w-100"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" className="me-2" />
                                            Rejestracja...
                                        </>
                                    ) : (
                                        '📝 Zarejestruj się'
                                    )}
                                </Button>
                            </Form>

                            <div className="text-center mt-3">
                                <small className="text-muted">
                                    Masz już konto?{' '}
                                    <Link to="/login" className="text-decoration-none">
                                        Zaloguj się
                                    </Link>
                                </small>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Register;